import { Fragment } from 'react'

type Props = {
  text: string[]
}

export const MultilineText = ({ text }: Props) => {
  return (
    <>
      {text.map((line, i) => (
        <Fragment key={`${line}_${i}`}>
          {line}
          {i !== text.length - 1 && <br />}
        </Fragment>
      ))}
    </>
  )
}
